import { apiBase } from '@/api/instance';

export const Login = (parameter) => {
  return apiBase({
    url: '/auth/login',
    method: 'put',
    data: parameter
  });
};

export const Logout = (parameter) => {
  return apiBase({
    url: '/auth/logout',
    method: 'put',
    data: parameter
  });
};

export const SearchUser = (parameter) => {
  return apiBase({
    url: `/users`,
    method: 'get',
    data: parameter
  });
};

export const StoreUser = (parameter) => {
  return apiBase({
    url: '/users',
    method: 'post',
    data: parameter
  });
};

export const ShowUser = ({ id }) => {
  return apiBase({
    url: `/users/${id}`,
    method: 'get'
  });
};

export const UpdateUser = (parameter) => {
  return apiBase({
    url: `/users/${parameter.id}`,
    method: 'put',
    data: parameter
  });
};

export const DestroyUser = ({ id }) => {
  return apiBase({
    url: `/users/${id}`,
    method: 'delete'
  });
};
